import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function ColumnistsList() {
  const { selected } = useProvince();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/columnists${selected ? `?province_id=${selected.id}` : ""}`).then((r) => setItems(r.data || []));
  }, [selected?.id]);
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-1">Köşe Yazarları</h1>
      <p className="text-gray-500 text-sm mb-6">Yorumlar, analizler ve güncel meseleler.</p>
      <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((c) => (
          <div key={c.id} className="bg-white border border-gray-100 rounded-lg p-5 text-center">
            <img src={c.photo} alt={c.name} className="w-24 h-24 rounded-full mx-auto object-cover" />
            <Link to={`/kose-yazilari/${c.slug}`} className="block font-bold mt-3 hover:text-[#e11d2a]">{c.name}</Link>
            {c.latest_column && <Link to={`/yazi/${c.latest_column.slug}`} className="block text-sm text-gray-600 mt-2 line-clamp-2 hover:text-[#e11d2a]">{c.latest_column.title}</Link>}
            <Link to={`/kose-yazilari/${c.slug}`} className="inline-block mt-3 text-xs font-semibold text-[#e11d2a]">Tüm yazılar →</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
